import { captureEntryContextOnce } from '../common/entryContext';

export default defineNuxtPlugin({
  name: 'entry-context',
  enforce: 'pre',
  setup() {
    captureEntryContextOnce();
  },
});
